import React from 'react';

import { WpCollapsibleGroup, WpCollapsibleGroupItem } from '../';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

const CollapsibleGroupDocs = () => {
  const BasicExample = () => {
    return (
      <>
        <h5>Basic Example</h5>
        <WpContainer>
          <WpContainerBody>
            <WpCollapsibleGroup multiOpen={true} numbered defaultOpenIds={['one']}>
              <WpCollapsibleGroupItem
                title="Foster self-awareness, and awareness of the other person."
                collapsibleId="one"
              >
                Add whatever content you want here to be in the collapsible
              </WpCollapsibleGroupItem>
              <WpCollapsibleGroupItem title="Identify competing styles." collapsibleId="two">
                children two
              </WpCollapsibleGroupItem>
              <WpCollapsibleGroupItem title="Highlight competing goals." collapsibleId="three">
                children three
              </WpCollapsibleGroupItem>
              <WpCollapsibleGroupItem title="Pre-negotiate optimal ways of working together." collapsibleId="four">
                children four
              </WpCollapsibleGroupItem>
            </WpCollapsibleGroup>
          </WpContainerBody>
        </WpContainer>
      </>
    );
  };
  return <BasicExample />;
};

export default CollapsibleGroupDocs;
